import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Home from '../pages/Home';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BASEURL } from "../constants/Common"

const Authhome = (): JSX.Element => {
  const [authenticated, setAuthenticated] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        const response = await axios.get<{ message: string }>(
          //          'http://localhost:8000/authhome/',
          BASEURL + '/authhome/',
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`, // Send token in Authorization header
              'Content-Type': 'application/json',
            },
          }
        );
        setAuthenticated(true);
        console.log('user is authenticated');
        localStorage.setItem('authenticate', 'true');
        // toast.success('Login successful');
        console.log(
          'Value set in localStorage if logged:',
          localStorage.getItem('authenticate')
        );
      } catch (error) {
        console.log('Error:', error);
        setAuthenticated(false);
        console.log('user is not authenticated');
        localStorage.setItem('authenticate', 'false');
        console.log(
          'Value set in localStorage if not logged:',
          localStorage.getItem('authenticate')
        );
      } finally {
        setLoading(false);
      }
    };

    checkAuthentication(); // Check authentication status
  }, []);

  // if (loading) {
  //   return <div>Loading...</div>; // Show loading indicator while checking authentication
  // }

  // Render Home component if authenticated, otherwise render Login component
  return <Home  />
};

export default Authhome;
